export default __webpack_public_path__ + "static/media/mobile-bg-3.bf5e64e4.jpg";